import { IS_PRODUCTION } from "@/config";

// THIS IS A WORKAROUND TO MAKE SIGN UP CLEARER FOR NYC Health + Hospital Users (aka "Pediatricians")
export const NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID = IS_PRODUCTION ? 15503 : 56038;

export function isPediatricianSchool(schoolId?: number | null): boolean {
  if (!schoolId) return false;
  return schoolId === NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID;
}
